import AboutSection from './AboutSection';
import EntityBiographySection from './EntityBiographySection';
import ServicesSection from './ServicesSection';
import PortfolioSection from './PortfolioSection';
import AISection from './AISection';
import ResultsSection from './ResultsSection';
import PricingSection from './PricingSection';
import WhyDarksideSection from './WhyDarksideSection';
import ProcessSection from './ProcessSection';
import FaqSection from './FaqSection';
import CTASection from './CTASection';
import LocationBand from './LocationBand';
import Footer from '../../../components/feature/Footer';

/**
 * HomeBelowFold — all sections that appear below the hero.
 * Imported lazily from page.tsx so the hero can paint before this chunk loads.
 */
export default function HomeBelowFold() {
  return (
    <>
      <AboutSection />
      <EntityBiographySection />
      <ServicesSection />
      <PortfolioSection />
      <AISection />
      <ResultsSection />
      <PricingSection />
      <WhyDarksideSection />
      <ProcessSection />
      <FaqSection />
      <CTASection />
      <LocationBand />
      <Footer />
    </>
  );
}
